import { useApiStore } from "@/stores/api/index.ts";
import { useHttpStore } from "@/stores/http/index.ts";
import usePendo from "@/util/usePendo.js";
import { useMediaLibraryStore } from "@/stores/media-library/index.ts";

const fetchUser = async (module) => {
  const api = useApiStore();
  const httpStore = useHttpStore();
  const mediaLibraryStore = useMediaLibraryStore();

  const { rootGetters, dispatch, commit } = module;

  const touchscreenMode = rootGetters.getTouchScreen;

  let showCMS = true;
  let isSiteAdmin = false;
  let isInternal = false;
  let hasSiteAccess = false;
  let hasSignedAgreements = false;
  let siteIds = [];

  const isAuthenticated = await httpStore.auth0Client.isAuthenticated();

  if (isAuthenticated) {
    try {
      const { data } = await api.authorizeUser();
      hasSiteAccess = true;
      isSiteAdmin = data.isSiteAdmin;
      isInternal = data.isInternal;
      hasSignedAgreements = data.hasSignedAgreements;

      // fetch site IDs user has access to
      if (!isInternal) {
        try {
          const { data: userSiteIdsResponse } = await api.userSiteIds();
          siteIds = userSiteIdsResponse;
        } catch (err) {
          console.log("Error fetching site IDs", err);
        }
      }
    } catch (err) {
      // 401 - user is logged in but doesn't have access to site.
      showCMS = false;
      hasSiteAccess = false;
      console.log(err);
    }

    const { email } = await httpStore.auth0Client.getUser();

    if (email) {
      await dispatch("setUserEmail", email, { root: true });
    }
  } else {
    showCMS = false;
  }

  await dispatch("setIsAdmin", isSiteAdmin, { root: true });
  await dispatch("setIsInternal", isInternal, { root: true });
  await dispatch("setHasSignedAgreements", hasSignedAgreements, { root: true });
  await commit(
    "setAuth",
    isAuthenticated && hasSiteAccess && !touchscreenMode,
    {
      root: true,
    }
  );
  await commit("setSiteIds", siteIds, { root: true });
  await commit("setShowCMS", showCMS, { root: true });

  await dispatch("fetchSiteSwitcherSites");
  await mediaLibraryStore.fetchMediaItems();

  if (
    !import.meta.env.DEV &&
    !import.meta.env.VITE_PLAYWRIGHT_CI &&
    hasSignedAgreements
  ) {
    usePendo(module).initPendo();
  }
};

export { fetchUser };
